import React from 'react';
import { Translate } from 'react-redux-i18n';
import { RouteComponentProps, withRouter } from 'react-router-dom';

import photoHomme from '../../../../img/cartouche_homme.png';
import photoFemme from '../../../../img/cartouche_femme.png';
import camera from '../../../../img/icones/camera2.svg';
import { CONNECTION_INFO_FORM, PERSONAL_INFO_FORM } from '../../../../routes';
import chevronDroite from '../../../../img/icones/chevron_droite.svg';
import { MonIdentite } from '../../../../network/api/types/compte/MonIdentite';

type Props = RouteComponentProps & {
  myIdentity: MonIdentite,
  openPhotoModal: () => void,
  pseudo: string,
};

class ConnectionInformationBox extends React.Component<Props> {
  componentDidMount(): void {
  }

  render(): React.ReactElement {
    const photo = this.props.myIdentity?.photo || (this.props.myIdentity?.civilite === 'Madame' ? photoFemme : photoHomme);
    return (
      <div className="account-box connection-info-box">
        <div className="box-img prof-img">
          <div className="container-img">
            <img
              className="profile-pic"
              src={photo}
              alt="my profile"
            />
            <button
              type="button"
              onClick={this.props.openPhotoModal}
            >
              <label htmlFor="add-photo-home" className="add-photo-label">
                <img
                  className="add-foto"
                  src={camera}
                  alt="ajouter ou modifier"
                />
              </label>
            </button>
          </div>
          <div className="responsive-title">
            <div className="box-line column no-border">
              <h4>
                <div className="title-background primary" />
                <Translate value="CONNECTION_INFORMATION.CONNECTION_INFORMATION" />
              </h4>
              <div className="subtitle">
                <Translate value="CONNECTION_INFORMATION.CONFIDENTIAL" />
              </div>
            </div>
          </div>
        </div>
        <div className="info-column">
          <div className="box-line column title">
            <h4>
              <div className="title-background primary" />
              <Translate value="CONNECTION_INFORMATION.CONNECTION_INFORMATION" />
            </h4>
            <div className="subtitle">
              <Translate value="CONNECTION_INFORMATION.CONFIDENTIAL" />
            </div>
          </div>
          <div className="box-line">
            <button
              type="button"
              className="info-row"
              onClick={() => this.props.history.push(CONNECTION_INFO_FORM)}
            >
              <div className="chevron-helper">
                <h5 className="button-title">
                  <Translate value="CONNECTION_INFORMATION.CONNECTION_ID" />
                </h5>
                <div className="button-subtitle">
                  {this.props.pseudo}
                </div>
              </div>
              <img
                className="chevron"
                src={chevronDroite}
                alt="chevron"
              />
            </button>
          </div>
          <div className="box-line password">
            <button
              type="button"
              className="info-row"
              onClick={() => this.props.history.push(CONNECTION_INFO_FORM)}
            >
              <div className="chevron-helper">
                <h5 className="button-title">
                  <Translate value="CONNECTION_INFORMATION.PASSWORD" />
                </h5>
                <div className="button-subtitle">
                  <Translate value="CONNECTION_INFORMATION.PASSWORD_PLACEHOLDER" />
                </div>
              </div>
              <img
                className="chevron"
                src={chevronDroite}
                alt="chevron"
              />
            </button>
          </div>
          <div className="box-line no-border">
            <button
              type="button"
              className="info-row"
              onClick={() => this.props.history.push(PERSONAL_INFO_FORM)}
            >
              <div className="chevron-helper">
                <Translate value={this.props.myIdentity?.managedByFicen
                  ? 'CONNECTION_INFORMATION.SEE_PERSONAL_INFO' : 'CONNECTION_INFORMATION.UPDATE_PERSONAL_INFO'}
                />
              </div>
              <img
                className="chevron"
                src={chevronDroite}
                alt="chevron"
              />
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(ConnectionInformationBox);
